import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  FilterPopover,
  Input,
  Label,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@shared/ui';

export function PopoverShowcase() {
  const { t } = useTranslation();
  const [filterValue, setFilterValue] = useState('example');

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.overlay.popover.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.overlay.popover.description')}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center gap-3">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="outline">{t('uiLibrary.overlay.popover.trigger')}</Button>
          </PopoverTrigger>
          <PopoverContent className="w-64">
            <Text size="sm">{t('uiLibrary.overlay.popover.content')}</Text>
          </PopoverContent>
        </Popover>
        <FilterPopover
          activeFilterCount={filterValue.length > 0 ? 1 : 0}
          clearLabel={t('uiLibrary.overlay.popover.filterClear')}
          label={t('uiLibrary.overlay.popover.filterLabel')}
          onClear={() => {
            setFilterValue('');
          }}
        >
          <div className="space-y-1">
            <Label htmlFor="ui-library-filter-popover-example">
              {t('uiLibrary.overlay.popover.filterName')}
            </Label>
            <Input
              id="ui-library-filter-popover-example"
              value={filterValue}
              onChange={(event) => {
                setFilterValue(event.target.value);
              }}
            />
          </div>
        </FilterPopover>
        <FilterPopover
          activeFilterCount={2}
          clearLabel={t('uiLibrary.overlay.popover.filterClear')}
          disabled
          label={t('uiLibrary.overlay.popover.disabledFilterLabel')}
        >
          <Text>{t('uiLibrary.overlay.popover.content')}</Text>
        </FilterPopover>
      </CardContent>
    </Card>
  );
}
